module.exports = __webpack_public_path__ + "img/saude2.a4856b3a.svg";